import { Compass, Rocket, Sprout, Users, Wand2 } from "lucide-react";
import { Section, SectionHeading, StickerCard } from "@/components/ui";
import { SubjectPicker } from "@/components/home/SubjectPicker";
import { CURIOSITY } from "@/data/home";

const STEP_ICONS = {
  explore: Compass,
  experience: Rocket,
  create: Wand2,
  connect: Users,
  grow: Sprout,
};

/** Full literals so Tailwind sees them. One calm style for every step. */
const STEP_STYLES = [{ tone: "brandTint", badge: "bg-brand-500 text-white" }];

export function CuriositySection() {
  return (
    <Section labelledBy="curiosity-title" testId="home-curiosity">
      <div className="relative z-10">
        <SectionHeading id="curiosity-title" title={CURIOSITY.title} highlight="See where it takes you." intro={CURIOSITY.intro} />

        <ol className="mt-8 grid gap-3 sm:grid-cols-2 lg:grid-cols-5">
          {CURIOSITY.steps.map((step, i) => {
            const Icon = STEP_ICONS[step.id] ?? Compass;
            const style = STEP_STYLES[i % STEP_STYLES.length];
            return (
              <li key={step.id}>
                <StickerCard tone={style.tone} className="h-full">
                  <span className={`mb-3 inline-flex h-11 w-11 items-center justify-center rounded-full ${style.badge}`}>
                    <Icon className="h-5 w-5" aria-hidden="true" />
                  </span>
                  <h3 className="font-heading text-xl font-bold">{step.title}</h3>
                  <p className="mt-1 text-sm text-ink/70 sm:text-base">{step.text}</p>
                </StickerCard>
              </li>
            );
          })}
        </ol>

        <SubjectPicker />
      </div>
    </Section>
  );
}

